module.exports = __webpack_public_path__ + "static/media/lv_court.23b61fdc.png";